import { css as a, ct as n } from "@/styled-system/css";
const r = a.raw({
  display: "flex",
  marginInlineStart: {
    base: n("Banner.spacing.gap.trailing"),
    md: "auto"
  }
});
export {
  r as bannerCloseRecipe
};
//# sourceMappingURL=banner-close.styles.js.map
